import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '../pages/config'
import { slugGenerator } from '../../utils/slugGenerator'

const ServiceCard = ({ obj , icon }) => {
    return (
        <div className="col-lg-4 col-md-6 mb-30" >
            <div className="services-item">
                <div className="services-images">
                    <img className="main-img" src={`${config.imageurl}${obj.image}`} alt="" />
                    <div className="services-icon">
                        <img className="main-icons" src={icon} alt="" />
                    </div>
                </div>
                <div className="services-text">
                    <div className="services-title">
                        <h3 className="title">
                            <a href={`${config.appUrl}service/${obj?.slug}`}>{obj?.name}</a>
                        </h3>
                    </div>
                    <p className="services-txt">{obj?.title}</p>
                    <div className="services-btn">
                        <Link to={`${config.appUrl}service/${obj?.slug}`}>
                            <span className="btn-text">
                                Read More
                            </span>
                            <i className="bi bi-arrow-right-short"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceCard